import {
	Autocomplete,
	type AutocompleteProps,
	type AutocompleteRenderInputParams,
} from '@mui/material'
import type { ReactNode } from 'react'

export interface OrganisationOption {
	id: string
	name?: string
}

const getOrganisationLabel = (option: { name?: string } | string): string =>
	typeof option === 'string' ? option : option.name || ''

type SharedAutocompleteProps<
	Option extends OrganisationOption,
	Multiple extends boolean,
	FreeSolo extends boolean,
> = Pick<
	AutocompleteProps<Option, Multiple, false, FreeSolo>,
	| 'value'
	| 'defaultValue'
	| 'onChange'
	| 'onInputChange'
	| 'filterSelectedOptions'
	| 'isOptionEqualToValue'
	| 'renderOption'
	| 'getOptionLabel'
	| 'multiple'
	| 'freeSolo'
>

interface OrganisationRecipientAutocompleteProps<
	Option extends OrganisationOption,
	Multiple extends boolean,
	FreeSolo extends boolean,
> extends SharedAutocompleteProps<Option, Multiple, FreeSolo> {
	options: readonly Option[]
	renderInput: (params: AutocompleteRenderInputParams) => ReactNode
}

const OrganisationRecipientAutocomplete = <
	Option extends OrganisationOption = OrganisationOption,
	Multiple extends boolean = false,
	FreeSolo extends boolean = false,
>({
	getOptionLabel = getOrganisationLabel,
	...props
}: OrganisationRecipientAutocompleteProps<Option, Multiple, FreeSolo>) => (
	<Autocomplete<Option, Multiple, false, FreeSolo>
		fullWidth
		getOptionLabel={getOptionLabel}
		{...props}
	/>
)

export { getOrganisationLabel, OrganisationRecipientAutocomplete }
